import(/* webpackMode: "eager" */ "/home/ubuntu/download/695a9e937683ed0014254bad/gullklar_landing_page/src/app/vilkar/page.tsx");
